import React from "react";
import {
    COLLECTION_SORT_OPTIONS,
    getCollectionSortOptionLabel,
    loadCollectionSortKey,
    normalizeCollectionSortKey,
    saveCollectionSortKey,
} from "../utils/collectionSort";

const CollectionSortControl = ({
    value,
    onChange,
    id = "collection-sort",
    className = "",
    label = "Sort",
}) => {
    const sortKey = normalizeCollectionSortKey(
        value !== undefined && value !== null ? value : loadCollectionSortKey()
    );

    const handleChange = (event) => {
        const next = saveCollectionSortKey(event.target.value);
        if (typeof onChange === "function") {
            onChange(next);
        }
    };

    const rootClassName = ["collectionSortControl", className]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={rootClassName}>
            <label className="collectionSortControl__label" htmlFor={id}>
                {label}
            </label>
            <select
                id={id}
                className="collectionSortControl__select"
                value={sortKey}
                onChange={handleChange}
                aria-label={`${label}: ${getCollectionSortOptionLabel(sortKey)}`}
            >
                {COLLECTION_SORT_OPTIONS.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CollectionSortControl;
